import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fad8603c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = {
  key: 0,
  class: "card-action float-end"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_12 = { class: "card-title text-truncate" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }, null, -1))
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่เกิดเหตุ:")
], -1))
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "col-sm-6" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารแนบ:")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_22 = { class: "text-muted mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmergencyAnswerComponent = _resolveComponent("EmergencyAnswerComponent")!
  const _component_EmergencyAttachmentOffcanvasComponent = _resolveComponent("EmergencyAttachmentOffcanvasComponent")!
  const _component_EmergencyFormComponent = _resolveComponent("EmergencyFormComponent")!
  const _component_EmergencyAttachmentModalComponent = _resolveComponent("EmergencyAttachmentModalComponent")!
  const _component_EmergencyAttachmentFormComponent = _resolveComponent("EmergencyAttachmentFormComponent")!
  const _component_EmergencyImageModalComponent = _resolveComponent("EmergencyImageModalComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isOrs || _ctx.isProvince)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("ul", _hoisted_5, [
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
                      }, [
                        _hoisted_7,
                        _createTextVNode("แก้ไขข้อมูล ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.attachmentClick && _ctx.attachmentClick(...args)))
                      }, [
                        _hoisted_9,
                        _createTextVNode("จัดการเอกสารแนบ ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isOrs || _ctx.isProvince)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "dropdown-item",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
                      }, [
                        _hoisted_11,
                        _createTextVNode("จัดการรูปภาพประกอบ ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("h5", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.emergency?.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.emergency?.emergencyDate ? _ctx.thaiDate(_ctx.emergency?.emergencyDate) : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAttachment && _ctx.showAttachment(...args)), ["stop","prevent"]))
              }, " ดูเอกสารแนบ ")
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_21,
          _withDirectives(_createElementVNode("p", _hoisted_22, null, 512), [
            [_directive_dompurify_html, _ctx.emergency?.description ? _ctx.emergency?.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-']
          ])
        ])
      ])
    ]),
    _createVNode(_component_EmergencyAnswerComponent, {
      "emergency-id": _ctx.emergency?.id
    }, null, 8, ["emergency-id"]),
    _createVNode(_component_EmergencyAttachmentOffcanvasComponent, {
      ref: "emergencyAttachmentOffcanvas",
      "emergency-id": _ctx.emergency?.id
    }, null, 8, ["emergency-id"]),
    _createVNode(_component_EmergencyFormComponent, {
      ref: "emergencyForm",
      "emergency-type-id": _ctx.emergency?.emergencyType.id,
      "province-id": _ctx.emergency?.province.id,
      "emergency-id": _ctx.emergency?.id
    }, null, 8, ["emergency-type-id", "province-id", "emergency-id"]),
    _createVNode(_component_EmergencyAttachmentModalComponent, {
      ref: "emergencyAttachmentModel",
      "emergency-id": _ctx.emergency?.id,
      onUpload: _ctx.uploadClick
    }, null, 8, ["emergency-id", "onUpload"]),
    _createVNode(_component_EmergencyAttachmentFormComponent, {
      ref: "emergencyAttachmentForm",
      "emergency-id": _ctx.emergency?.id,
      onHidden: _ctx.uploadClose
    }, null, 8, ["emergency-id", "onHidden"]),
    _createVNode(_component_EmergencyImageModalComponent, {
      ref: "emergencyImageModal",
      "emergency-id": _ctx.emergency?.id
    }, null, 8, ["emergency-id"])
  ], 64))
}